import { Tooltip } from '../../../../components';
import './ResultSubItem.css';

export const ResultSubItem = ({ 
  backgroundColor = 'white',
  nestedBackgroundColor,
  title, 
  tooltip, 
  content, 
  sideContent, 
  isExpanded = false,
  children 
}) => {
  const containerClass = `result-sub-item ${
    backgroundColor === 'blue' ? 'result-sub-item--blue' : backgroundColor === 'white' ? 'result-sub-item--white' : ''
  }`.trim();

  const expandedClass = `result-sub-item__expanded ${
    isExpanded ? 'result-sub-item__expanded--visible' : 'result-sub-item__expanded--collapsed'
  } ${
    nestedBackgroundColor === 'blue' ? 'result-sub-item__expanded--blue' : nestedBackgroundColor === 'white' ? 'result-sub-item__expanded--white' : ''
  }`.trim();

  return (
    <div className={containerClass}>
      <div className="result-sub-item__row">
        <div className="result-sub-item__row-wrapper">
          {/* Left column - Title */}
          <div className="result-sub-item__title-column">
            <h3 className="result-sub-item__title">{title}</h3>
            {tooltip && <Tooltip text={tooltip} />}
          </div>
          
          {/* Middle column - Content */}
          <div className="result-sub-item__content-column">
            {content}
          </div>
          
          {/* Right column - Side content */}
          {sideContent && (
            <div className="result-sub-item__side-column">
              {sideContent}
            </div>
          )}
        </div>
        
        {/* Expanded panel */}
        {children && (
          <div className={expandedClass}>
            <div className="result-sub-item__expanded-content">
              {children}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

